import { IconButton, Stack, Text, Tooltip, useDisclosure } from '@chakra-ui/react';
import { dimensionUnitOptions, weightTypeOptions, weightUnitOptions } from '@pelicargo/utils';
import { HiInformationCircle } from 'react-icons/hi2';

import { themeVar } from '../config/theme/tenantTheme';
import { SimpleSwitch } from './SimpleSwitch';

export const CargoDetails = () => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();

  return (
    <Stack
      direction={{ base: 'column', lg: 'row' }}
      align={{ base: 'flex-start', lg: 'center' }}
      justify="space-between"
      spacing="4"
      w="full"
    >
      <Stack direction="row" align="center" position="relative">
        <SimpleSwitch variant="inline" fieldVariant="inline" name="cargo_details" options={weightTypeOptions} />
        <Tooltip
          hasArrow
          placement="bottom"
          label="Use Weight Per Piece when the weight should be multiplied by # of pieces in each line. Use Gross Weight when the weight entered is the gross weight of all items in each line."
          bg="bg.inverse"
          color="text.inverse"
          isOpen={isOpen}
        >
          <IconButton
            height="auto"
            minW="auto"
            aria-label="Toggle tooltip"
            variant="unstyled"
            icon={<HiInformationCircle color={themeVar('icon.infoBg', 'currentColor')} />}
            onMouseOver={onOpen}
            onMouseLeave={onClose}
            onClick={onToggle}
          />
        </Tooltip>
      </Stack>

      <Stack direction="row" align="center" justify={{ base: 'flex-start', lg: 'flex-end' }} w="full">
        <Text zIndex={0}>Units</Text>
        <SimpleSwitch
          variant="inline"
          fieldVariant="inline"
          name="original_dimension_unit"
          spacing="0"
          options={dimensionUnitOptions}
        />
        <SimpleSwitch
          variant="inline"
          fieldVariant="inline"
          name="original_weight_unit"
          spacing="0"
          options={weightUnitOptions}
        />
      </Stack>
    </Stack>
  );
};
